import { BriefCampaignInf } from "@shared/lib/types/briefCampains";
import { formatData } from "@shared/lib/utils/formatData";
import styles from "./styles.module.scss";

function money(value?: number) {
  if (value === undefined) return "—";
  return `₹${formatData(value, "0,00.00")}`;
}

function statusMeta(status?: string) {
  if (status === "Paid")
    return { label: "Paid", className: styles.paymentPaid };
  if (status === "Partially-Paid") {
    return { label: "Partially paid", className: styles.paymentPartial };
  }
  if (status === "Pending")
    return { label: "Unpaid", className: styles.paymentPending };
  if (status === "N/A")
    return { label: "Not applicable", className: styles.paymentNa };
  return null;
}

export function PaymentAmountCell({
  paid,
  total,
  status,
}: {
  paid?: number;
  total?: number;
  status?: string;
}) {
  const meta = statusMeta(status);
  const hasAmount = paid !== undefined || total !== undefined;
  if (status === "N/A") {
    return (
      <span className={`${styles.paymentStatus} ${styles.paymentNa}`}>
        Not applicable
      </span>
    );
  }

  return (
    <div className={styles.paymentGrid}>
      {hasAmount ? (
        <>
          <span className={styles.paymentLineLabel}>Paid</span>
          <span className={styles.paymentLineValue}>{money(paid)}</span>
          <span className={styles.paymentLineLabel}>Total</span>
          <span className={styles.paymentLineValue}>{money(total)}</span>
        </>
      ) : (
        <span className={styles.paymentEmpty}>No amount yet</span>
      )}
      {meta ? (
        <span className={`${styles.paymentStatus} ${meta.className}`}>
          {meta.label}
        </span>
      ) : null}
    </div>
  );
}

export function BillingDetailsCell({ record }: { record: BriefCampaignInf }) {
  const billing = record.vendorBilling;
  if (!record.isVendorBillingAttached || !billing) {
    return (
      <div className={styles.paymentCell}>
        {/* <span className={styles.billingName}>Not attached</span> */}
        <span className={styles.billingMeta}>Billing is still pending</span>
      </div>
    );
  }

  const phone = [billing.countryCode, billing.phoneNumber]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.paymentCell}>
      <span className={styles.billingName}>
        {billing.name || "Billing attached"}
      </span>
      {phone ? <span className={styles.billingMeta}>{phone}</span> : null}
      {billing.emailId ? (
        <span className={styles.billingMeta}>{billing.emailId}</span>
      ) : null}
      <div className={styles.billingChips}>
        {billing.type === "Agency" && billing.agency?.name ? (
          <span className={`${styles.billingChip} ${styles.billingChipAgency}`}>
            Agency: {billing.agency.name}
          </span>
        ) : null}
        {billing.isGst ? (
          <span className={`${styles.billingChip} ${styles.billingChipGst}`}>
            GST linked
          </span>
        ) : null}
      </div>
    </div>
  );
}
